<footer class="access mt-5 footer-areas footer-style-twos footer-style-fives">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6">
                <div class="footer-widget">
                    <div class="footer-logo">
                        <img style=" height:50px;" src="assets/img/logo/eultr.png" alt="logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-sm-6">
                <div class="footer-widget mt-3  ">
                    <h3>Nous contacter</h3>
                    <ul>
                        <li> <a
                                href="mailto:contact@centre-formation-apostolique.fr">contact@eulogia-enseignement.fr</a>
                        </li>
                        <li><a href="tel:+33695340678">+33 6 95 34 06 78</a></li>
                    </ul>

                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="adresse footer-widget ">
                    <h3>Adresse</h3>
                    <ul>
                        <li><a href="#">15 Rue Léonard de
                                Vinci, 92160, Antony</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">

                <div class="col-lg-8 col-md-9 lh-1">
                    <p>&copy;2024 Eulogia. Tout droit réservés par <a> Digitrium</a><a
                            style="color:#9a215b;font-weight:bold" routerLink="/terms-of-service"> - Conditions
                            générales d'utilisation</a></p>

                </div>
            </div>
        </div>
    </div>
</footer>

<div class="top-btn">
    <i class="flaticon-startup"></i>
</div>